// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Route, NavigationGuardNext} from 'vue-router';
import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

export enum AccountRouteNames {
  AccountsPage = 'AccountsPage',
  AccountsDetailsPage = 'AccountsDetailsPage',
  AddAccountPage = 'AddAccountPage',
  ApexAddAccountPage = 'ApexAddAccountPage',
  VerifyIdentityPage = 'VerifyIdentityPage',
}

export default [
  {
    path: '/clientdashboard/accounts',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    name: AccountRouteNames.AccountsPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/accounts/AccountsPage.vue'),
  },
  {
    path: '/clientdashboard/accounts/:id',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    name: AccountRouteNames.AccountsDetailsPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/accounts/AccountsDetailsPage.vue'),
    props: true,
  },
  {
    path: '/clientdashboard/add-account',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    name: AccountRouteNames.AddAccountPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/components/add-account/AddAccount.vue'),
    meta: {
      CMS: true,
    },
    props: true,
    children: [
      {
        path: ':reqid',
        name: AccountRouteNames.ApexAddAccountPage,
        meta: {
          CMS: true,
        },
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/components/add-account/CustodianAddAccount.vue'),
        props: true,
        beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
          store.dispatch('goal/setToAdd', null);
          await store.dispatch('goal/getGoalSelection');

          next();
        },
      },
    ],
  },
  {
    path: '/clientdashboard/addaccount/identity/:reqid',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    name: AccountRouteNames.VerifyIdentityPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/components/account/VerifyIdentity.vue'),
  },
];
